import { useMutation } from '@tanstack/react-query';
import { PermanentJobsService } from '../services';
import { IParsePostingApiRequest, IParsePostingResult } from '../types';

/**
 * Parses pasted job-description text via the read-only `POST /postings/parse`
 * endpoint. Read-only — it does not persist anything; the caller creates the
 * draft separately. Error handling is left to the call site (`showErrorMessage`)
 * so the pasted text is preserved and the user can retry.
 */
export const useParsePosting = () => {
  return useMutation<IParsePostingResult, Error, IParsePostingApiRequest>({
    mutationKey: ['parsePosting'],
    mutationFn: PermanentJobsService.parsePosting,
  });
};
